import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative min-h-screen flex-col overflow-x-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "lazyload",
  "data-script": "https://accounts.google.com/gsi/client"
}, null, -1)

import {
  computed,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from 'vue';
import {
  useRoute,
} from 'vue-router';
import BusNotification from '@/components/App/BusNotification.vue';
import FooterComponent from '@/components/App/FooterComponent.vue';
import GoogleOneTap from '@/components/App/GoogleOneTap.vue';
import PropNotification from '@/components/App/PropNotification.vue';
import StockMarketChoice from '@/components/App/StockMarketChoice.vue';
import HeaderComponent from '@/components/NavBar/HeaderComponent.vue';
import PushNotificationHistorySidebar from '@/components/Sidebar/PushNotificationHistorySidebar.vue';
import {
  viewportBreakpoint,
} from '@/helpers';
import {
  useStore,
} from '@/store';
import {
  IAppHandlerMessage,
} from '@/type';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


let storageEventHandler: (e: StorageEvent) => void;
let resizedBreakpointEventHandler: (e: Event) => void;

const route = useRoute();
const authStore = useStore.auth;
const appStore = useStore.app;

const user = computed(() => authStore.user);
const token = computed(() => authStore.token);
const device = computed(() => appStore.device);

const showDefaultHeaderFooter = computed(() => {
  const { fullPath } = route;
  return !fullPath.startsWith('/auth')
    && !fullPath.startsWith('/admin');
});

const isWebview = computed(() => useStore.app.device.isFlutterWebview || useStore.app.device.isAndroidWebview);

const isSafariAlertClosed = ref(false);

const showSafariAlert = computed(() => {
  if (!device.value.isSafari || !user.value || isSafariAlertClosed.value) {
    return false;
  }
  const { name } = route;
  return name === 'Home' || name === 'Dashboard';
});

watch(() => appStore.sidebars.pushNotificationHistory.show, (newVal) => {
  if (newVal) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }
});

watch(() => isWebview, () => {
  _handleAppWebView('init');
});
watch(() => user.value, () => {
  _handleAppWebView('change:auth');
});

function _handleAppWebView(type: IAppHandlerMessage['type']): void {
  if (!isWebview.value) {
    return;
  }

  const message: IAppHandlerMessage = {
    type,
    serverToken: token.value,
    user: user.value,
  };
  const stringifiedMessage = JSON.stringify(message);

  console.log('_handleAppWebView -> appHandler.postMessage : ', stringifiedMessage);
  window.appHandler.postMessage(stringifiedMessage);
}

onMounted(() => {
  window.setTimeout(() => {
    _handleAppWebView('init');
  }, 1 * 1000);
});

onBeforeMount(() => {
  storageEventHandler = (e: StorageEvent): void => {
    if (e.key === 'token') {
      // local storage token changed
      console.log(`Key Changed: ${e.key}`);
      window.sessionStorage.removeItem('token');
      window.location.reload();
    }
  };
  resizedBreakpointEventHandler = (e: Event): void => {
    const resizedBreakpoint = viewportBreakpoint();
    if (resizedBreakpoint !== appStore.breakpoint) {
      appStore.breakpoint = resizedBreakpoint;
    }
  };
  window.addEventListener('resize', resizedBreakpointEventHandler);
  window.addEventListener('storage', storageEventHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener('storage', storageEventHandler);
  window.removeEventListener('resize', resizedBreakpointEventHandler);
});


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(showDefaultHeaderFooter))
      ? (_openBlock(), _createBlock(HeaderComponent, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(user) && _unref(user).role === 'non-admin')
      ? (_openBlock(), _createBlock(PushNotificationHistorySidebar, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      _createVNode(BusNotification),
      (_unref(showSafariAlert))
        ? (_openBlock(), _createBlock(PropNotification, {
            key: 0,
            notification: "Looks like you are using Safari. Notifications work better in\n          other browsers like chrome, firefox, edge etc.",
            notificationType: "INFO",
            maxWidth: "400px",
            onClose: _cache[0] || (_cache[0] = ($event: any) => (isSafariAlertClosed.value = true))
          }))
        : _createCommentVNode("", true),
      _createVNode(GoogleOneTap),
      (_unref(user)?.stockExchanges && !_unref(user)?.stockExchanges.length)
        ? (_openBlock(), _createBlock(StockMarketChoice, {
            key: 1,
            class: "z-10"
          }))
        : (_openBlock(), _createBlock(_component_RouterView, { key: 2 }))
    ]),
    (_unref(showDefaultHeaderFooter))
      ? (_openBlock(), _createBlock(FooterComponent, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})